"use strict";

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _taggedTemplateLiteral = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n        subscription {\n          output: subscribeBlockMinded\n        }"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        subscription (\n          $account: String!\n        ) {\n          output: subscribeAccountPaymentChannelUpdated (\n            account: $account\n          ) {\n            sender\n            recipient\n            token\n            hash\n            uid\n            totalAmount\n            committedAmount\n            senderSignature\n            guardianSignature\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        subscription (\n          $account: String!\n        ) {\n          output: subscribeAccountEventProcessed (\n            account: $account\n          ) {\n            transaction {\n              state\n              hash\n              from\n              to\n              gas\n              gasUsed\n              gasPrice\n              input\n              value\n              createdAt\n              updatedAt\n            }\n            hash\n            name\n            payload\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        subscription (\n          $account: String!\n        ) {\n          output: subscribeAccountDepositUpdated (\n            account: $account\n          ) {\n            token\n            internalAmount\n            externalAmount\n            availableAmount\n            lockedAmount\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        subscription (\n          $account: String!\n        ) {\n          output: subscribeAccountAuthKeyUpdated (\n            account: $account\n          ) {\n            address\n            type\n            deployed\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        subscription (\n          $account: String!\n        ) {\n          output: subscribeAccountUpdated (\n            account: $account\n          ) {\n            address\n            deployed\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        mutation (\n          $sender: String!\n          $senderSignature: String!\n          $recipient: String!\n          $token: String\n          $uid: String!\n          $amount: BN!\n        ) {\n          output: updatePaymentChannels (\n            sender: $sender\n            senderSignature: $senderSignature\n            recipient: $recipient\n            token: $token\n            uid: $uid\n            amount: $amount\n          ) {\n            sender\n            recipient\n            token\n            hash\n            uid\n            totalAmount\n            committedAmount\n            senderSignature\n            guardianSignature\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $account: String!\n          $page: Float\n        ) {\n          output: getAccountPaymentChannels (\n            account: $account\n            page: $page\n          ) {\n            items {\n              sender\n              recipient\n              token\n              hash\n              uid\n              totalAmount\n              committedAmount\n              senderSignature\n              guardianSignature\n              createdAt\n              updatedAt\n            }\n            nextPage\n          }\n        }"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $hash: String!\n        ) {\n          output: getPaymentChannel (\n            hash: $hash\n          ) {\n            sender\n            recipient\n            token\n            hash\n            uid\n            totalAmount\n            committedAmount\n            senderSignature\n            guardianSignature\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $account: String!\n          $page: Float\n        ) {\n          output: getAccountEvents (\n            account: $account\n            page: $page\n          ) {\n            items {\n              transaction {\n                state\n                hash\n                from\n                to\n                gas\n                gasUsed\n                gasPrice\n                input\n                value\n                createdAt\n                updatedAt\n              }\n              hash\n              name\n              payload\n              createdAt\n              updatedAt\n            }\n            nextPage\n          }\n        }"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $hash: String!\n        ) {\n          output: getAccountEvent (\n            hash: $hash\n          ) {\n            transaction {\n              state\n              hash\n              from\n              to\n              gas\n              gasUsed\n              gasPrice\n              input\n              value\n              createdAt\n              updatedAt\n            }\n            hash\n            name\n            payload\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $account: String!\n          $page: Float\n        ) {\n          output: getAccountAuthKeys (\n            account: $account\n            page: $page\n          ) {\n            items {\n              address\n              type\n              deployed\n              createdAt\n              updatedAt\n            }\n            nextPage\n          }\n        }"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $account: String!\n          $authKey: String!\n        ) {\n          output: getAccountAuthKey (\n            account: $account\n            authKey: $authKey\n          ) {\n            address\n            type\n            deployed\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $account: String!\n          $token: String\n        ) {\n          output: getAccountDeposit (\n            account: $account\n            token: $token\n          ) {\n            token\n            internalAmount\n            externalAmount\n            availableAmount\n            lockedAmount\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $account: String!\n        ) {\n          output: getAccount (\n            account: $account\n          ) {\n            address\n            externalDepositAddress\n            deployed\n            createdAt\n            updatedAt\n          }\n        }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_boost_1 = require("apollo-boost");

var eth_sdk_1 = require("eth-sdk");

var AbstractGraphQLClient_1 = require("./AbstractGraphQLClient");

var PlatformClient = /*#__PURE__*/function (_AbstractGraphQLClien) {
  _inherits(PlatformClient, _AbstractGraphQLClien);

  var _super = _createSuper(PlatformClient);

  function PlatformClient() {
    _classCallCheck(this, PlatformClient);

    return _super.apply(this, arguments);
  }

  _createClass(PlatformClient, [{
    key: "getAccount",
    value: function getAccount(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.query(apollo_boost_1.gql(_templateObject()), options).then(function (output) {
                  return PlatformClient.prepareAccount(output);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getAccountDeposit",
    value: function getAccountDeposit(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.query(apollo_boost_1.gql(_templateObject2()), options).then(function (output) {
                  return PlatformClient.prepareAccountDeposit(output);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getAccountAuthKey",
    value: function getAccountAuthKey(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.query(apollo_boost_1.gql(_templateObject3()), options).then(function (output) {
                  return PlatformClient.prepareAccountAuthKey(output);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getAccountAuthKeys",
    value: function getAccountAuthKeys(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.query(apollo_boost_1.gql(_templateObject4()), options).then(function (output) {
                  return PlatformClient.preparePaginated(output, PlatformClient.prepareAccountAuthKey);
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getAccountEvent",
    value: function getAccountEvent(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.query(apollo_boost_1.gql(_templateObject5()), options).then(function (output) {
                  return PlatformClient.prepareAccountEvent(output);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getAccountEvents",
    value: function getAccountEvents(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.query(apollo_boost_1.gql(_templateObject6()), options).then(function (output) {
                  return PlatformClient.preparePaginated(output, PlatformClient.prepareAccountEvent);
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getPaymentChannel",
    value: function getPaymentChannel(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.query(apollo_boost_1.gql(_templateObject7()), options).then(function (output) {
                  return PlatformClient.preparePaymentChannel(output);
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getAccountPaymentChannels",
    value: function getAccountPaymentChannels(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.query(apollo_boost_1.gql(_templateObject8()), options).then(function (output) {
                  return PlatformClient.preparePaginated(output, PlatformClient.preparePaymentChannel);
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "updatePaymentChannels",
    value: function updatePaymentChannels(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.mutate(apollo_boost_1.gql(_templateObject9()), options).then(function (output) {
                  return PlatformClient.preparePaymentChannel(output);
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "subscribeAccountUpdated",
    value: function subscribeAccountUpdated(options) {
      return this.subscribe(apollo_boost_1.gql(_templateObject10()), options).map(function (output) {
        return PlatformClient.prepareAccount(output);
      });
    }
  }, {
    key: "subscribeAccountAuthKeyUpdated",
    value: function subscribeAccountAuthKeyUpdated(options) {
      return this.subscribe(apollo_boost_1.gql(_templateObject11()), options).map(function (output) {
        return PlatformClient.prepareAccountAuthKey(output);
      });
    }
  }, {
    key: "subscribeAccountDepositUpdated",
    value: function subscribeAccountDepositUpdated(options) {
      return this.subscribe(apollo_boost_1.gql(_templateObject12()), options).map(function (output) {
        return PlatformClient.prepareAccountDeposit(output);
      });
    }
  }, {
    key: "subscribeAccountEventProcessed",
    value: function subscribeAccountEventProcessed(options) {
      return this.subscribe(apollo_boost_1.gql(_templateObject13()), options).map(function (output) {
        return PlatformClient.prepareAccountEvent(output);
      });
    }
  }, {
    key: "subscribeAccountPaymentChannelUpdated",
    value: function subscribeAccountPaymentChannelUpdated(options) {
      return this.subscribe(apollo_boost_1.gql(_templateObject14()), options).map(function (output) {
        return PlatformClient.preparePaymentChannel(output);
      });
    }
  }, {
    key: "subscribeBlockMinded",
    value: function subscribeBlockMinded() {
      return this.subscribe(apollo_boost_1.gql(_templateObject15()));
    }
  }], [{
    key: "preparePaginated",
    value: function preparePaginated(paginated, prepare) {
      var nextPage = paginated.nextPage,
          items = paginated.items;
      return {
        nextPage: nextPage,
        items: Object.values(items).map(function (value) {
          return prepare(value);
        })
      };
    }
  }, {
    key: "prepareDates",
    value: function prepareDates(createdAt, updatedAt) {
      return {
        createdAt: createdAt ? new Date(createdAt) : null,
        updatedAt: updatedAt ? new Date(updatedAt) : null
      };
    }
  }, {
    key: "prepareAccount",
    value: function prepareAccount(item) {
      var result = null;

      if (item) {
        var nonce = item.nonce,
            createdAt = item.createdAt,
            updatedAt = item.updatedAt,
            raw = __rest(item, ["nonce", "createdAt", "updatedAt"]);

        result = Object.assign(Object.assign({
          nonce: eth_sdk_1.toBN(nonce)
        }, raw), PlatformClient.prepareDates(createdAt, updatedAt));
      }

      return result;
    }
  }, {
    key: "prepareAccountDeposit",
    value: function prepareAccountDeposit(item) {
      var result = null;

      if (item) {
        var availableAmount = item.availableAmount,
            externalAmount = item.externalAmount,
            internalAmount = item.internalAmount,
            lockedAmount = item.lockedAmount,
            createdAt = item.createdAt,
            updatedAt = item.updatedAt,
            raw = __rest(item, ["availableAmount", "externalAmount", "internalAmount", "lockedAmount", "createdAt", "updatedAt"]);

        result = Object.assign(Object.assign({
          availableAmount: eth_sdk_1.toBN(availableAmount),
          externalAmount: eth_sdk_1.toBN(externalAmount),
          internalAmount: eth_sdk_1.toBN(internalAmount),
          lockedAmount: eth_sdk_1.toBN(lockedAmount)
        }, raw), PlatformClient.prepareDates(createdAt, updatedAt));
      }

      return result;
    }
  }, {
    key: "prepareAccountAuthKey",
    value: function prepareAccountAuthKey(item) {
      var result = null;

      if (item) {
        var createdAt = item.createdAt,
            updatedAt = item.updatedAt,
            raw = __rest(item, ["createdAt", "updatedAt"]);

        result = Object.assign(Object.assign({}, raw), PlatformClient.prepareDates(createdAt, updatedAt));
      }

      return result;
    }
  }, {
    key: "prepareAccountEvent",
    value: function prepareAccountEvent(item) {
      var result = null;

      if (item) {
        var createdAt = item.createdAt,
            updatedAt = item.updatedAt,
            transaction = item.transaction,
            raw = __rest(item, ["createdAt", "updatedAt", "transaction"]);

        result = Object.assign(Object.assign({
          transaction: PlatformClient.prepareTransaction(transaction)
        }, raw), PlatformClient.prepareDates(createdAt, updatedAt));
      }

      return result;
    }
  }, {
    key: "prepareTransaction",
    value: function prepareTransaction(item) {
      var result = null;

      if (item) {
        var gasPrice = item.gasPrice,
            value = item.value,
            createdAt = item.createdAt,
            updatedAt = item.updatedAt,
            raw = __rest(item, ["gasPrice", "value", "createdAt", "updatedAt"]);

        result = Object.assign(Object.assign({
          gasPrice: eth_sdk_1.toBN(gasPrice),
          value: eth_sdk_1.toBN(value)
        }, raw), PlatformClient.prepareDates(createdAt, updatedAt));
      }

      return result;
    }
  }, {
    key: "preparePaymentChannel",
    value: function preparePaymentChannel(item) {
      var result = null;

      if (item) {
        var committedAmount = item.committedAmount,
            totalAmount = item.totalAmount,
            createdAt = item.createdAt,
            updatedAt = item.updatedAt,
            raw = __rest(item, ["committedAmount", "totalAmount", "createdAt", "updatedAt"]);

        result = Object.assign(Object.assign({
          committedAmount: eth_sdk_1.toBN(committedAmount),
          totalAmount: eth_sdk_1.toBN(totalAmount)
        }, raw), PlatformClient.prepareDates(createdAt, updatedAt));
      }

      return result;
    }
  }]);

  return PlatformClient;
}(AbstractGraphQLClient_1.AbstractGraphQLClient);

exports.PlatformClient = PlatformClient;